import React from "react";
import { ElementGroup } from '@whalecloud/page-builder-core/constant';
import HeaderCell from "./components/HeaderCell";
import HeaderCellSettings from "./components/HeaderCellSettings";
import { ReactComponent as PluginSvg } from "@assets/icons/header_cell_setting.svg";
import { getLocale } from '@utils/util';

export default () => {
  const messages = getLocale();
  return {
    name: 'headerCell',
    group: ElementGroup.COMPLEX,
    target: ["table"],
    title: messages['PAGEBUIDER_ELEMENT_FORM_HEADERCELL'],
    toolBarPreview: <PluginSvg />,
    data: {
      settings: {
        margin: {
          desktop: { all: 0 },
          mobile: { all: 0 }
        },
        padding: {
          desktop: { all: 0 },
          mobile: { all: 0 }
        },
      },
      columnSettings: {
        title: messages['PAGEBUIDER_EDITOR_TABLE_HEADER_CELL'],
        dataIndex: '',
        ellipsis: false,
        render: (text, record, index) => text,
      },
    },
    pluginComponent: HeaderCell, // 插件渲染组件
    pluginSettingComponent: HeaderCellSettings, // 插件设置项组件
  }
}
